import { createFileRoute } from '@tanstack/react-router'

import UpdaterSectionPage from '@/features/Admin/UpdaterManagement/Components/UpdaterSectionPage.tsx'

export const Route = createFileRoute('/_authenticated/admin/updates/completed')(
    {
        component: RouteComponent,
    },
)

function RouteComponent() {
    return (
        <UpdaterSectionPage
            status="completed"
            titleKey="admin.updater.updatesCompleted.title"
            descriptionKey="admin.updater.updatesCompleted.description"
        />
    )
}
